const BREAKPOINTS: { [k: string]: number } = {
  LARGE: 1340,
  DESKTOP: 1144,
  TABLET: 820,
  MOBILE: 480,
};

export default BREAKPOINTS;
